export const setTheme = (theme) => {
  const root = document.documentElement

  root.classList.remove('light', 'dark', 'mix', 'echo')
  root.classList.add(theme)

  localStorage.setItem('app-theme', theme)
}